// Carved verbatim from `src/features/agent-harness/hooks.ts` (ARCFE-1079 · D4).
// `transport` is REQUIRED here — see `query/useQueryRun.ts` for why the
// `agentHarnessClient` default stays app-side.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { agentHarnessKeys } from '../../contracts/keys';
import type { RunTransport } from '../../contracts/transport';

export const useMutateCancelTurn = (transport: RunTransport) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (agentRunId: string) => transport.cancelTurn(agentRunId),
    onSuccess: (_data, agentRunId) => {
      void queryClient.invalidateQueries({
        queryKey: agentHarnessKeys.run(agentRunId),
      });
    },
  });
};
